module.exports = __webpack_public_path__ + "static/img/product02.eae1b9ac.png";